import React, { Component } from 'react';
import './DishBlock.css'
import makeCloudinaryUrlForPhoto from  '../../utils/makeCloudinaryUrlForPhoto'

class DishBlock extends Component {
  render() {
    let {name, id, photo, price, description, type, subMenuId} = this.props
    let targetStylingClass = ` category-${subMenuId} id-${id}`
    name = name && name.en
    description = description && description.en
    let src = makeCloudinaryUrlForPhoto(photo, {width: 1200})
    // let src = "https://images.unsplash.com/photo-1484499972849-a19291def0ab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1047&q=80"

    switch (type) {
      case 'image':
        return(
          <article
            className={"image-text item draggable-handle" + targetStylingClass} key={id}>
            <div style={{
                  backgroundImage: `url("${src}")`
                }}
                className="photo-container"></div>
            <div className="image-text__hover-name">
              <span>{name}</span>
            </div>
          </article>
        )
        break;
      case 'text':
        return(
          <article className={"dish-text item draggable-handle" + targetStylingClass} key={id}>
              <div className="meta"><span className="name">{name}</span>
              <span className="price">{price}</span></div>
            <div className="dish__description"><span>{description}</span></div>
          </article>
        )
        break;
      default:

    }

    return(
      <article className={"item draggable-handle" + targetStylingClass} key={id}>

          <div style={{
                backgroundImage: `url("${src}")`
              }}
              className="photo-container"></div>
          <div className="meta"><span className="name">{name}</span>
          {price? <span className="price">{price}</span>: null}
          </div>
        <div className="dish__description"><span>{description}</span></div>
      </article>
    )
  }
}
export default DishBlock
